import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import FormComponent from 'modules/core/components/Form'
import FormRow from 'modules/core/components/FormRow'
import PanesHeader from 'modules/core/components/PanesHeader'
import PanesPadForm from 'modules/core/components/PanesPadForm'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { employeeLegalEntity } from 'modules/core/lib/employeeLegalEntity'
import { formGetDirtyFields } from 'modules/core/lib/formGetDirtyFields'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'

import {
  FormTypes,
  useEmployeePersonalProvider,
} from 'modules/employees/components/blocks/EmployeePersonalProvider'
import type Employee from 'modules/employees/store/models/Employee'

import AddressInput from './AddressInput'

interface Props {
  employee: Employee
  readonly?: boolean
  errors?: Record<string, string[] | Record<string, string>> | undefined | null
}

export const EmployeeAddressBlock = observer((props: Props) => {
  const { employee, readonly, errors } = props
  const {
    addressForm,
    onSubmit: onSubmitAddress,
    disableSectionSaveButtons,
  } = useEmployeePersonalProvider()
  const legalEntity = employeeLegalEntity(employee)

  const onSubmit = () => {
    onSubmitAddress([FormTypes.ADDRESS])
    track(trackingEvents.employee.editEmployeeInformationSubmit, {
      fields_edited: formGetDirtyFields(addressForm),
      legal_entity_country: legalEntity.country,
      layout_version: 'v1',
    })
  }

  useUnsafeEffect(() => {
    errors && addressForm.setErrors(errors)
  }, [errors, addressForm]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <FormComponent onSubmit={onSubmit}>
      <FormRow>
        <AddressInput mandatory form={addressForm} readonly={readonly} showCues />
      </FormRow>
      {!disableSectionSaveButtons && addressForm.isDirty && (
        <FormRow footer>
          <Button submit>{i18n.t('common.submit')}</Button>
        </FormRow>
      )}
    </FormComponent>
  )
})

const EmployeeAddress = (props: Props) => {
  return (
    <PanesPadForm direction="horizontal" boxed>
      <PanesHeader
        illustration="sign-post"
        title={i18n.t('employee_form.address.title')}
        description={i18n.tCurrent(
          'employee_form.address.description',
          employeeUser(props.employee).isCurrent()
        )}
      />
      <EmployeeAddressBlock {...props} />
    </PanesPadForm>
  )
}

export default observer(EmployeeAddress)
